var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotatearrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.292893 22.7929C-0.0976311 23.1834 -0.0976311 23.8166 0.292893 24.2071C0.683418 24.5976 1.31658 24.5976 1.70711 24.2071L0.292893 22.7929ZM24 1.5C24 0.947715 23.5523 0.499999 23 0.499998L14 0.499999C13.4477 0.499998 13 0.947714 13 1.5C13 2.05228 13.4477 2.5 14 2.5L22 2.5L22 10.5C22 11.0523 22.4477 11.5 23 11.5C23.5523 11.5 24 11.0523 24 10.5L24 1.5ZM1.70711 24.2071L23.7071 2.2071L22.2929 0.792891L0.292893 22.7929L1.70711 24.2071Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotatearrowWhite);
export default __webpack_public_path__ + "static/media/rotatearrowWhite.c75c915b8d21656d380a4cc931358c85.svg";
export { ForwardRef as ReactComponent };